import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";

const AssignAssetPopup = ({ asset, onClose, onAssign, users }) => {
  const [assignedTo, setAssignedTo] = useState(null);
  const [assignmentDate, setAssignmentDate] = useState(new Date());
  const [notes, setNotes] = useState("");
  const submitButtonRef = useRef(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const userOptions = users.map((user) => ({
    value: user.id,
    label: `${user.name}`,
  }));

  const isViewMode = asset && asset.assigned_to; // Set view mode if asset is already assigned

  useEffect(() => {
    // Prefill fields if assigning asset that has previous data
    if (asset) {
      setAssignedTo(asset.assigned_to ? { value: asset.assigned_to, label: asset.assigned_user_name } : null);
      setAssignmentDate(asset.assignment_date ? new Date(asset.assignment_date) : new Date());
      setNotes(asset.notes || ""); // Assume asset.notes if previously added notes
    }
  }, [asset]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!assignedTo) {
      toast.error("Please select a user to assign the asset.");
      return;
    }

    const assignmentData = {
      assignedTo: assignedTo.value,
      assignmentDate: assignmentDate ? assignmentDate.toISOString().split("T")[0] : null,
      notes,
    };

    try {
      const response = await axios.put(`${apiUrl}/assets/asset/assign/${asset.id}`, assignmentData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Asset assigned successfully");
      onAssign(response.data);

      // Reset form fields
      setAssignedTo(null);
      setAssignmentDate(new Date());
      setNotes("");
      if (submitButtonRef.current) {
        submitButtonRef.current.click();
      }
    } catch (error) {
      console.error("Error assigning asset:", error);
      toast.error("Failed to assign the asset. Please try again.");
    }
  };

  return (
<div id="assign_asset" className="modal custom-modal fade" role="dialog">
  <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "50%" }}>
    <div className="modal-content h-100 d-flex flex-column">
      <form onSubmit={handleSubmit}>
        <div className="modal-header">
          <h5 className="modal-title">Assign Asset</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body flex-grow-1 overflow-auto" style={{ maxHeight: "calc(100vh - 120px)" }}>
          <div className="row mb-3" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', alignItems: 'center' }}>
            <div className="col-md-3">
              <label className="col-form-label">Assign To <span className="text-danger">*</span></label>
            </div>
            <div className="col-md-9">
              {isViewMode ? (
                <div className="form-control-plaintext">{assignedTo?.label || "Unassigned"}</div>
              ) : (
                <Select
                  options={userOptions}
                  value={assignedTo}
                  onChange={setAssignedTo}
                  placeholder="Select User"
                  className="flex-grow-1"
                />
              )}
            </div>
          </div>
          <div className="row mb-3" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', alignItems: 'center' }}>
            <div className="col-md-3">
              <label className="col-form-label">Assignment Date <span className="text-danger">*</span></label>
            </div>
            <div className="col-md-9">
              {isViewMode ? (
                <div className="form-control-plaintext">{assignmentDate ? assignmentDate.toLocaleDateString() : "N/A"}</div>
              ) : (
                <DatePicker
                  selected={assignmentDate instanceof Date && !isNaN(assignmentDate) ? assignmentDate : null}
                  onChange={(date) => setAssignmentDate(date)}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                />
              )}
            </div>
          </div>
          <div className="row mb-3" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', alignItems: 'center' }}>
            <div className="col-md-3">
              <label className="col-form-label">Notes</label>
            </div>
            <div className="col-md-9">
              {isViewMode ? (
                <div className="form-control-plaintext">{notes || "No additional notes"}</div>
              ) : (
                <textarea
                  className="form-control"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  rows="3"
                  placeholder="Optional notes for assignment"
                />
              )}
            </div>
          </div>
        </div>
        {!isViewMode && (
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={onClose}>
              Close
            </button>
            <button className="btn btn-primary submit-btn" type="submit">
              Assign Asset
            </button>
          </div>
        )}
      </form>
      <div style={{ display: "none" }}>
        <button ref={submitButtonRef} data-bs-dismiss="modal" aria-label="Close" type="reset">
          HiddenSubmit
        </button>
      </div>
    </div>
  </div>
</div>

  );
};

export default AssignAssetPopup;
